import numberUtils from './../utils/numberUtils';
import isNil from 'lodash/isNil';

import type { RentalGrowthRentEstimateSource } from '@zg-rentals/ts-rental-growth-api-client';
import type { AddressApiType } from 'app/shared/types/ApiResponseTypes';
import type { MarketSummaryType } from 'app/shared/types/MarketSummaryType';

class Address {
  listingId: string | null;
  isUsersComp: boolean;
  homeType: string | null;
  propertyTypeCode: number | null;
  rentZestimate: number | null;
  rentZestimateRangeHigh: number | null;
  rentZestimateRangeLow: number | null;
  rentZestimateSource: RentalGrowthRentEstimateSource | null;
  beds: number | null;
  baths: number | null;
  sqft: number | null;
  pricePerSqft: string | null;
  lat: number | null;
  lon: number | null;
  zpid: number | null;
  street: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  unit: string | null;
  addressHasListing: boolean | null;
  marketSummary: MarketSummaryType | null;
  zrmListingId: string | null;

  constructor(res: AddressApiType = <AddressApiType>{}) {
    if (res) {
      this.listingId = !isNil(res.zpid) ? res.zpid.toString() : null;
      this.isUsersComp = true;
      this.homeType = !isNil(res.homeType) ? res.homeType : null;
      this.propertyTypeCode = !isNil(res.propertyTypeCode) ? res.propertyTypeCode : null;
      this.rentZestimate = !isNil(res.zestimate && res.zestimate.rentZestimate) ? res.zestimate.rentZestimate : null;
      this.rentZestimateRangeHigh = !isNil(res.zestimate && res.zestimate.rentZestimateRangeHigh)
        ? res.zestimate.rentZestimateRangeHigh
        : null;
      this.rentZestimateRangeLow = !isNil(res.zestimate && res.zestimate.rentZestimateRangeLow)
        ? res.zestimate.rentZestimateRangeLow
        : null;
      this.rentZestimateSource = res.zestimate?.source ?? null;
      this.beds = !isNil(res.numBeds) ? res.numBeds : null;
      this.baths = !isNil(res.numFullBaths) ? res.numFullBaths : null;
      this.sqft = !isNil(res.minSqft) ? res.minSqft : null;
      this.pricePerSqft =
        !isNil(this.rentZestimate) && !isNil(this.sqft)
          ? `$${numberUtils.trimDecimal(this.rentZestimate / this.sqft, 2)}`
          : null;
      this.lat = !isNil(res.geo) && !isNil(res.geo.lat) ? res.geo.lat : null;
      this.lon = !isNil(res.geo) && !isNil(res.geo.lon) ? res.geo.lon : null;
      this.zpid = !isNil(res.zpid) ? res.zpid : null;
      this.street = !isNil(res.address) ? res.address.street : null;
      this.city = !isNil(res.address) ? res.address.city : null;
      this.state = !isNil(res.address) ? res.address.state : null;
      this.zip = !isNil(res.address) ? res.address.zip : null;
      this.unit = !isNil(res.address) ? res.address.unit : null;
      this.addressHasListing = !isNil(res.addressHasListing) ? res.addressHasListing : null;
      this.marketSummary = res?.marketSummary ?? null;
      this.zrmListingId = !isNil(res.zrmListingId) ? res.zrmListingId : null;
    } else {
      this.listingId = null;
      this.isUsersComp = false;
      this.homeType = null;
      this.propertyTypeCode = null;
      this.rentZestimate = null;
      this.rentZestimateRangeHigh = null;
      this.rentZestimateRangeLow = null;
      this.rentZestimateSource = null;
      this.beds = null;
      this.baths = null;
      this.sqft = null;
      this.pricePerSqft = null;
      this.lat = null;
      this.lon = null;
      this.zpid = null;
      this.street = null;
      this.city = null;
      this.state = null;
      this.zip = null;
      this.unit = null;
      this.addressHasListing = null;
      this.marketSummary = null;
      this.zrmListingId = null;
    }
  }
}

export default Address;
